import { GET_NET_STATUS, SET_NET_STATUS } from '../constants/network';

export const getNetStatus = (url = '') => ({
  type: GET_NET_STATUS,
  url,
});

export const setNetStatus = online => ({
  type: SET_NET_STATUS,
  online,
});
